<template>
<div class="chapter">
<div class="inner_page">
<h1 class="h1"><strong>The<br/>Art<br/>of<br/>Business</strong></h1>
<p class="subtitle"><em>Make All Your Work<br/>a Work of Art</em></p>
<p class="author" id="ch00_fm03_title"><a id="page_iii"></a><em>Stan Davis</em> <strong><span class="small">AND</span></strong> <em>David McIntosh</em></p>
<p class="publisher"><img alt="image" src="images/pub.jpg"/></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch00_fm03_title.vue?65a567a2